import styled from 'styled-components';

import { ScrollableContainer } from '@web/components/ScrollableContainer/ScrollableContainer';

export const ScrollContainer = styled(ScrollableContainer)`
  display: flex;
  flex-flow: row wrap;
  gap: 5px;
  height: 100%;
  // vertical "padding" is 20px
  // scrollbar track has 2px padding
  // we want to have 5px gap on the right side of the scrollbar
  // so 5px - scrollbar track:
  margin-right: 3px;
  // and right padding: 20px - scrollbar width (11px) - right gap:
  padding: 0 ${({ shouldApplyFallback }) => (shouldApplyFallback ? '20px' : '6px')} 0 20px;

  & > svg {
    display: block;
  }
`;
